<template>   
    <div style="background:white; height:100vh">
        <el-tabs :animated="false" v-model="tabVal" @tab-click= "tabClick">
            <el-tab-pane  name="tab01">
                <span slot="label" ><i class="iconfont icon-yuandianxiao"></i> 系统模块</span>
            </el-tab-pane>
            <el-tab-pane  name="tab02">
                <span slot="label"><i class="iconfont icon-yuandianxiao"></i> 系统表单</span>
            </el-tab-pane>
            <el-tab-pane  name="tab03">
                <span slot="label"><i class="iconfont icon-yuandianxiao"></i> 模块 -- 表单 -- 报表</span>
            </el-tab-pane>
            <el-tab-pane  name="tab04">
                <span slot="label"><i class="iconfont icon-yuandianxiao"></i> 系统报表</span>
            </el-tab-pane>
        </el-tabs>
        <span v-if="tabVal=='tab01'" >
            <div style="width:100%; margin-top:-12px; background:#f7f8f9;line-height:30px;height:37px; padding-left:2px;border-bottom:2px solid #389">
                <el-link :disabled="disabled" :underline="false" @click="addRec" style="font-size:12px; font-weight:500;margin-left:5px;"><i class="iconfont icon-xinzeng" style="color:#409eff;"></i> 增加模块</el-link> 
                <el-select v-model="selparam" size="small"  placeholder="请选择列名" clearable @change="elchange" style="width:150px;margin-left:20px">
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:400px; vertical-align:center;height:30px;">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input>                     
            </div> 
            <div style="margin-top:1px;">
                <el-table  :data="baseData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="tabHeight" 
                    :row-key="getFldKey"  
                    ref="tabref"
                    highlight-current-row>
                    <el-table-column label="序号" type="index" width="60"></el-table-column>                    
                    <el-table-column  v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                                    
                        :sortable="item.sortable=='N'"
                        :min-width="item.width">
                        <template slot-scope="scope">                    
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column> 
                    
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="editRec(scope.row,scope.$index)" :underline="false"  ><span style="font-size:13px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px; "></i>
                            <el-link :disabled="disabled" @click="delRec(scope.row )" :underline="false"  ><span style="font-size:13px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                      
                </el-table> 
                 
                <el-dialog v-dialogDrag :visible.sync="addModal" width="750px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" >
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{type==='create'?'新增记录':'修改记录'}}</span>
                    </div>   
                    <Form ref="addForm" :model="formCol" :label-width="100"   label-position="right" inline >
                        <FormItem class="item-width" :label=" item.title"  v-for="(item,index) in tabCol" :key="index" :prop="item.key" >
                            <el-checkbox size="medium"   border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                            <el-input v-else type="text" :disabled="item.disabled=='Y'?true:false||index==0" v-model="formCol[item.key]"  style="width:100%" clearable/>
                        </FormItem>
                    </Form>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                        <span style="float:right">
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addModal=false" style="margin-right:50px;">取消</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="modal_ok" style="margin-right:10px;">保存</el-button>
                        </span>
                    </div>
                </el-dialog>                              
            </div>
        </span>
        <span v-else-if="tabVal=='tab02'">  
            <div style="width:100%; margin-top:-12px;background:#f7f8f9;line-height:30px;height:37px; padding-left:2px;border-bottom:2px solid #389">
                <el-link :disabled="disabled" :underline="false" @click="addRec2" style="font-size:12px; font-weight:500;margin-left:5px;"><i class="iconfont icon-xinzeng" style="color:#409eff;"></i> 增加表单</el-link> 
                <el-select v-model="selparam2" size="small" placeholder="请选择列名" clearable  style="width:150px;margin-left:20px">
                    <span v-for="item in frmArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold2" v-model="txtparam2" @keyup.enter.native="qryFormData" size="small" style="width:360px;  height:30px;">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="qryFormData" style="color:#409eff"></el-button>
                </el-input>                     
            </div> 
            <div style="margin-top:1px;">
                <el-table  :data="frmData.slice(0,rangeNumber)" 
                    border                 
                    class="custom-table-border"           
                    disabled-hover
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="400" 
                    v-loadmore:rangeNumber=tableMore(rangeNumber)
                    :row-key="getFldKey"  
                    @row-click="getFrmRow"
                    ref="formref"
                    highlight-current-row>
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column  v-for="(item,index ) in frmArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'"
                        :min-width="item.width">
                        <template   slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column> 
               
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="140">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="editRec2(scope.row )" :underline="false"  ><span style="font-size:13px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px; "></i>
                            <el-link :disabled="disabled" @click="delRec2(scope.row )" :underline="false"  ><span style="font-size:13px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                      
                </el-table> 
                <div class="one-toolbar" >
                    <span class="spanRow">表单单据编码生成方式
                        <el-link   @click="addGen" :underline="false"  ><span style="font-size:13px;color:white;">【 <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px; "></i> 新增记录 】 </span></el-link>
                    </span>
                </div>
                <el-table  :data="genData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:-9px;"
                    size="small"
                    :height="genHeight" 
                    ref="genref"
                    highlight-current-row>   
                    <el-table-column  v-for="(item,index ) in genArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="180">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="editGen(scope.row,scope.$index )" :underline="false"  ><span style="font-size:13px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:10px;"></i>
                            <el-link :disabled="disabled" @click="delGen(scope.row,scope.$index )" :underline="false"  ><span style="font-size:13px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                      
                </el-table> 
                <el-dialog v-dialogDrag :visible.sync="frmModal" width="750px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{frmtype==='create'?'新增记录':'修改记录'}}</span>
                    </div>   
                    <Form  :model="formRow" :label-width="100"   label-position="right" inline >
                        <FormItem class="item-width" :label=" item.title"  v-for="(item,index) in frmArr.filter(item=>item.fhide=='N')" :key="index" :prop="item.key" >
                            <el-checkbox   border  v-if="item.edcss=='checkbox'" style="width:100%" true-label="Y" false-label="N" v-model="formRow[item.key]"></el-checkbox>
                            <el-select   v-else-if="item.key=='ISQRY'" v-model="formRow[item.key]"  style="width:100%">
                                <span v-for="(item,index) in formArr" :key='index'>
                                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                </span>
                            </el-select>
                            <el-input   v-else type="text" :disabled="item.disabled=='Y'?true:false||index==0" v-model="formRow[item.key]" style="width:100%" clearable/>
                        </FormItem>
                    </Form>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                        <span style="float:right">
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="frmModal=false" style="margin-right:50px;">取消</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="form_Save" style="margin-right:10px;">保存</el-button>
                        </span>
                    </div>
                </el-dialog> 
                <el-dialog v-dialogDrag :visible.sync="genWin" width="850px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">表单编码生成方式</span>
                    </div> 
                    <Form  :model="genRow" :label-width="100"   label-position="right" inline >
                        <template v-for="(item,index) in genArr" >
                            <FormItem  class="item-width" :label=" item.title"  :key="index"  v-if="item.fhide==='N'"  >
                                <el-select v-if="item.key==='ITMNO'" v-model="genRow[item.key]" filterable style="width:100%">
                                    <span v-for="item in codeArr" :key='item.key'>
                                        <el-option :label="item.CNAME" :value="item.CODE"></el-option>
                                    </span>
                                </el-select>
                                <el-select v-else-if="item.key==='DTTMFMT'" v-model="genRow[item.key]" filterable style="width:100%">
                                    <span v-for="item in dttmArr" :key='item.key'>
                                        <el-option :label="item.CNAME" :value="item.CODE"></el-option>
                                    </span>
                                </el-select>
                                <el-input v-else type="text" :disabled="item.disabled=='Y'?true:false " v-model="genRow[item.key]" style="width:100%" clearable/>
                            </FormItem>
                        </template>
                    </Form>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                        <span style="float:right">
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="genWin=false" style="margin-right:50px;">取消</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="gen_Save" style="margin-right:10px;">保存</el-button>
                        </span>
                    </div>
                </el-dialog>                  
            </div>
        </span>  
        <!-- 模块--表单 --报表              -->
        <span v-else-if="tabVal=='tab03'" >           
            <div class="one-toolbar" style="margin-top:-12px">
                 <span class="spanRow">模块明细</span>
            </div>
            <el-table  :data="baseData" 
                border                            
                disabled-hover
                class="custom-table-border"
                style="overflow:auto;margin-top:1px;"
                size="small"
                :height="250" 
                @row-click="modRow"
                highlight-current-row>
                <el-table-column label="序号" type="index" width="65" fixed ></el-table-column>
                
                <el-table-column v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                    <template slot-scope="scope">                    
                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column> 
                           
            </el-table>
            <!-- <div class="one-toolbar">
                <span class="spanRow">模块 > 表单明细 【
                <i class="iconfont icon-xinzeng" style="color:#fff;"></i> 
                <el-link :disabled="disabled" :underline="false" @click="addRec3" style="font-size:12px; font-weight:500;margin-left:5px;color:#fff;border-bottom:1px solid white">增加表单到模块下</el-link> 】
                </span>
            </div> -->
            <el-tabs v-model="activeTab" style="background:#ccc;">
                <el-tab-pane name="first" >
                    <span  slot="label" style="margin-left:10px">模块-表单明细 【
                        <i class="iconfont icon-xinzeng" style="color:#fff;"></i> 
                        <el-link   :underline="false" @click="addRec3" style="font-size:12px; font-weight:500;margin-left:5px;color:#fff;border-bottom:1px solid white">增加表单到模块下</el-link> 】
                    </span>
                </el-tab-pane>
                <el-tab-pane name="second">
                    <span  slot="label">模块-报表明细 【
                        <i class="iconfont icon-xinzeng" style="color:#fff;"></i> 
                        <el-link   :underline="false" @click="addRec5" style="font-size:12px; font-weight:500;margin-left:5px;color:#fff;border-bottom:1px solid white">增加报表到模块下</el-link> 】
                    </span>
                </el-tab-pane>
            </el-tabs>
            <span v-if="activeTab=='first'" > 
                <el-table  :data="mfData" 
                    border                 
                    class="custom-table-border"           
                    disabled-hover
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="mfHigh" 
                    highlight-current-row>              
                    <el-table-column  v-for="(item,index ) in mfArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'"
                        :min-width="item.width">
                        <template slot-scope="scope">                    
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column>         
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="140">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="editRec3(scope.row )" :underline="false"  ><span style="font-size:13px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px; "></i>
                            <el-link :disabled="disabled" @click="delRec3(scope.row )" :underline="false"  ><span style="font-size:13px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                    
                </el-table> 
            </span>
            <span v-if="activeTab=='second'" >
                <el-table  :data="mrData" 
                    border          
                    class="custom-table-border"                  
                    disabled-hover
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="mfHigh" 
                    highlight-current-row>
                    <el-table-column   v-for="(item,index ) in mrArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.edcss!=='chkeckbox'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="240">
                        <template slot-scope="scope">
                            <i class="iconfont icon-fenzhijiedian" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="alloRole(scope.row )" :underline="false"  ><span style="font-size:13px;margin-right:10px;">分配到角色</span></el-link>
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="editRec5(scope.row )" :underline="false"  ><span style="font-size:13px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:10px;"></i>
                            <el-link :disabled="disabled" @click="delRec5(scope.row )" :underline="false"  ><span style="font-size:13px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                    
                </el-table> 
            </span>
            <el-dialog v-dialogDrag :visible.sync="mfModal" width="750px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">模块-表单</span>
                    </div> 
                <Form  :model="mfRow" :label-width="100"   label-position="right" inline >
                    <template v-for="(item,index) in mfArr" >
                        <FormItem class="item-width" :label=" item.title"  :key="index"  v-if="item.fhide==='N'"  >
                            <el-select v-if="item.key==='FRMIDSEQ'" v-model="mfRow[item.key]" filterable style="width:100%">
                                <span v-for="item in formSel" :key='item.key'>
                                    <el-option :label="item.FRMNM" :value="item.IDSEQ"></el-option>
                                </span>
                            </el-select>
                            <el-input v-else type="text" :disabled="item.disabled=='Y'?true:false " v-model="mfRow[item.key]"  style="width:100%" clearable/>
                        </FormItem>
                    </template>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="mfModal=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="mf_Save" style="margin-right:10px;">保存</el-button>
                    </span>
                </div>
            </el-dialog>  
        </span>
        <span v-else-if="tabVal=='tab04'" >                      
            <div style="width:100%; margin-top:-12px; background:#f7f8f9;line-height:30px;height:37px; padding-left:2px;border-bottom:2px solid #389">
                <el-link :disabled="disabled" :underline="false" @click="addRec4" style="font-size:12px; font-weight:500;margin-left:5px;"><i class="iconfont icon-xinzeng" ></i><span style="color:#5cadee"> 增加报表</span></el-link> 
                <el-select v-model="selparam3" size="small" placeholder="请选择列名" clearable  style="width:150px;margin-left:20px">
                    <span v-for="item in repArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold2" v-model="txtparam3" @keyup.enter.native="qryRepData" size="small" style="width:360px;  height:30px;">
                    <el-select v-model="oper3" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="qryRepData" style="color:#409eff"></el-button>
                </el-input>                  
            </div> 
            <div style="margin-top:1px;">
                <el-table  :data="repData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="tabHeight" 
                    :row-key="getFldKey"  
                    @row-click="getFrmRow"
                    ref="refrep"
                    highlight-current-row>
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column  v-for="(item,index ) in repArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="180">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="editRec4(scope.row )" :underline="false"  ><span style="font-size:13px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:10px;"></i>
                            <el-link :disabled="disabled" @click="delRec4(scope.row,scope.$index )" :underline="false"  ><span style="font-size:13px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                      
                </el-table> 
            </div>
        </span>  
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style=" margin:15px 10px">
                {{prompt}}
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- 报表类 -->
        <el-dialog v-dialogDrag :visible.sync="repWin" width="750px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{repFlag==='create'?'新增记录':'编辑记录'}}</span>
            </div>   
            <Form  :model="repRow" :label-width="100"   label-position="right" inline >
                <FormItem   class="item-width"  v-for="(item,index) in repArr.filter(item=>item.fhide=='N')" :key="index" :prop="item.key" >
                    <template slot="label"><span style="color:red;margin-right:10px" v-if="item.key=='REPNM'">*</span>{{item.title}}</template>
                    <el-checkbox v-if="item.edcss=='checkbox'" style="width:100%" true-label="Y" false-label="N" v-model="repRow[item.key]"></el-checkbox>
                    <el-input v-else type="text" :disabled="item.disabled=='Y'?true:false " v-model="repRow[item.key]"  style="width:100%" clearable/>
                </FormItem>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="repWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="repSave" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog> 
        <el-dialog v-dialogDrag :visible.sync="mrWin" width="750px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">模块-报表</span>
            </div> 
            <Form  :model="mrRow" :label-width="100"   label-position="right" inline >
                <template v-for="(item,index) in mrArr" >
                    <FormItem class="item-width" :label=" item.title"  :key="index"  v-if="item.fhide==='N'"  >
                        <el-select v-if="item.key==='REPIDSEQ'" v-model="mrRow[item.key]" filterable style="width:100%">
                            <span v-for="item in repSel" :key='item.key'>
                                <el-option :label="item.REPNM" :value="item.IDSEQ"></el-option>
                            </span>
                        </el-select>
                        <el-select v-else-if="item.key==='FRMIDSEQ'" v-model="mrRow[item.key]" filterable style="width:100%">
                            <span v-for="item in formSel" :key='item.key'>
                                <el-option :label="item.FRMNM" :value="item.IDSEQ"></el-option>
                            </span>
                        </el-select>
                        <el-input v-else type="text" :disabled="item.disabled=='Y'?true:false " v-model="mrRow[item.key]"  style="width:100%" clearable/>
                    </FormItem>
                </template>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="mrWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="mr_Save" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="roleWin" width="520px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">用户明细</span>
            </div> 
            <div style="line-height:35px;display:flex;border-bottom:1px solid #ccc">
                <div style="width:50px;font-size:12px;font-weight:600;color:red; ">选择</div>
                <div style="width:60px;font-size:12px;font-weight:600;color:red; ">已分配</div>
                <div style="width:400px;font-size:12px;font-weight:600;color:red; ">用户名称</div>
            </div>
            <div style="height:300px;overflow-y:auto">  
                <div style="margin-top:8px">
                    <div v-for="(item,index) in roleArr" :key="index" style="display:flex;line-height:30px; ">
                        <div style="width:50px;font-size:12px;font-weight:600; "> 
                            <el-checkbox true-label="Y" false-label="N" v-model="item.SEL"></el-checkbox>
                        </div>
                        <div style="width:60px;font-size:12px;font-weight:600; "> 
                            <el-checkbox true-label="Y" disabled false-label="N" v-model="item.ISALLO"></el-checkbox>
                        </div>
                        <div style="width:400px;font-size:12px;font-weight:600; ">{{item.ROLENM}}</div>
                    </div>
                </div>
            </div>
            <div style="height:40px; border-top:1px solid #ccc;line-height:38px">
                <el-checkbox true-label="Y" border  size="small" false-label="N" @change="roleChg" v-model="v_selAll" label="全选"></el-checkbox>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="roleWin=false" style="margin-right:50px;margin-left:10px">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="role_Save" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>   
    </div>    
</template>

<script>
    import { getTabColOrData ,getBaseData} from '../../api/user';
 
    export default {
        name: "sys_mod",
        components: {
 
        },
        data () {
            return {
                roleWin:false,
                v_row:{},
                roleArr:[],
                v_selAll:'N',
                v_flag:'REP',
                rangeNumber:20,
                mrData:[],
                mrArr:[],
                mrWin:false,
                mrRow:{},
                activeTab:'first',
                repWin:false,
                tabVal:'tab01',
                genWin:false,
                promptWin:false,
                prompt:'',
                genRow:{},
                dttmArr:[],
                addModal:false, //modal 
                frmModal:false,
                txtparam:'', // input 绑定值
                selparam:'MODNM',// select 绑定值
                tabCol:[] ,//表列集合
                frmArr:[],
                mfData:[],
                input_hold:'请输入内容.回车以查询',
                txtparam2:'', // input 绑定值
                selparam2:'FRMNM',// select 绑定值
                input_hold2:'请输入内容.回车以查询',
                v_url:'xuper_auth/getTableRecMany', //api请求路径
                v_likeurl:'xuper_auth/getLikeManyRec', //多记录查询 like模式
                modidseq:'',
                modnm:'',
                v_sys:this.$cookies.get('v_sys'), //系统标志
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_corpid:this.$cookies.get('v_corpid') ,//corp id
                baseData:[] ,//表数据
                frmData:[] , //表单数据
                formCol:{MODNM:''}, //表格单行记录 model
                formRow:{FRMNM:''},
                mfArr:[],
                mfRow:{},
                mfModal:false,
                frmtype:'create',
                type:'create',
                formSel:[],
                disabled:false,
                genArr:[],
                genData:[],
                frmRow:{},
                codeArr:[],
                operArr:[],
                oper:'like',
                oper2:'like',
                oper3:'like',
                repData:[],
                repArr:[],
                repRow:{},
                selparam3:'REPNM',
                txtparam3:'',
                repFlag:'create',
                repSel:[],
                formArr:[],
            }
        },
        computed: {
            tabHeight(){
                return window.innerHeight-165+ 'px'
            }  ,
            genHeight(){
                return window.innerHeight-605+ 'px'
            }  ,
            mfHigh(){
                return window.innerHeight-480+ 'px'
            }  
        },
        created () {
            if (this.v_sys==='N'){ 
                this.disabled =true
            }
            if (this.v_username){ 
                this.getFormCol()
                
                this.qryFormData() //表单资料
            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        mounted() {
            //操作符
            getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
                this.operArr =res.result
            })
            getBaseData('xuper_auth/getBaseData','','','','','V_sys_form').then((res)=>{               
                this.formSel =res.result
            })
            getBaseData('xuper_auth/getBaseData','','','','','V_sys_rep').then((res)=>{               
                this.repSel =res.result
            }) 
            //自定义编码类型
            getBaseData('xuper_auth/getBaseData','PARENTNO','16012','','','v_sys_base','').then(res=>{
                this.codeArr =res.result
            }) 
            //自定义日期类型
            getBaseData('xuper_auth/getBaseData','PARENTNO','16005','','','v_sys_base','').then(res=>{
                this.dttmArr =res.result
            })  
            getBaseData('xuper_auth/getBaseData','PARENTNO','405973','','','v_sys_base','').then(res=>{
                this.formArr =res.result
            }) 
            getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_sys_role',' ORDER BY idNO').then(res=>{           
                this.roleArr =res.result
            })
            this.qryTabData()  //模块资料   
            this.qryRepData()
        },
        methods: {
            role_Save(){
                let v_arr =[]
                this.roleArr.forEach(item =>{
                    if (item['SEL']=='Y'){
                        v_arr.push(item)
                    }
                })
                if (v_arr.length ==0){
                    this.promptWin =true
                    this.prompt ='请选择行记录'
                }else {
                    if (this.v_flag =='REP') {
                        v_arr.forEach(item =>{
                            let v_idseq =item['IDSEQ']
                            let v_modidseq =this.v_row['MODIDSEQ'] ,v_repidseq =this.v_row['REPIDSEQ']
                            //先判断有没记录
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: { p_key:'idseq', p_value:v_idseq,p_key2:'MODIDSEQ',p_value2:v_modidseq,p_key3:'REPIDSEQ',p_value3:v_repidseq, p_table:'sys_user_priv' },
                            }).then(res=>{ 
                                if (res.result.length ==0) {
                                    let v_obj ={IDSEQ:v_idseq,LSTSEQ:'',MODIDSEQ:v_modidseq,REPIDSEQ:v_repidseq,PRIVTY:'REPORT',ISSEL:'Y'}
                                    //保存到 权限中
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(v_obj), p_table:'sys_user_priv',p_idseq:v_idseq},
                                    }).then(res=>{
                                        // 
                                    })
                                }
                            })
                        })
                    }else{
                        v_arr.forEach(item =>{
                            let v_idseq =item['IDSEQ']
                            let v_modidseq =this.v_rec['MODIDSEQ'] ,v_frmidseq =this.v_rec['FRMIDSEQ']
                            //先判断有没记录
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: { p_key:'idseq', p_value:v_idseq,p_key2:'MODIDSEQ',p_value2:v_modidseq,p_key3:'FRMIDSEQ',p_value3:v_frmidseq, p_table:'sys_user_priv' },
                            }).then(res=>{ 
                                if (res.result.length ==0) {
                                    let v_obj ={IDSEQ:v_idseq,LSTSEQ:'',MODIDSEQ:v_modidseq,FRMIDSEQ:v_frmidseq,PRIVTY:'FORM',ISSEL:'Y'}
                                    //保存到 权限中
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(v_obj), p_table:'sys_user_priv',p_idseq:v_idseq},
                                    }).then(res=>{
                                        if (res.code!=='200'){
                                            this.promptWin =true
                                            this.prompt =res.result
                                        }
                                    })
                                }
                            })
                        })
                    }
                    this.roleWin =false
                    this.$message.success('已分配成功')
                }
            },
            roleChg(val){
                if (val =='Y'){
                    this.roleArr.forEach(item =>{
                        item['SEL'] ='Y'
                    })
                }else{
                    this.roleArr.forEach(item =>{
                        item['SEL'] ='N'
                    })
                }
            },
            //分配报表到角色
            alloRole(row){
                this.roleWin =true
                this.v_row =JSON.parse(JSON.stringify(row))
                this.roleArr.forEach(item =>{
                    item['SEL']='N'      
                    item['ISALLO']='N'              
                })
                this.v_selAll ='N'
                this.v_flag ='REP'
                let v_modidseq = row['MODIDSEQ'] ,v_repidseq = row['REPIDSEQ']
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: { p_key:'ISSEL', p_value:'Y',p_key2:'MODIDSEQ',p_value2:v_modidseq,p_key3:'repIDSEQ',p_value3:v_repidseq, p_table:'sys_user_priv' },
                }).then(res=>{ 
                    let v_result =res.result 
                    this.roleArr.forEach(item =>{
                        v_result.some(it =>{
                            if (it['IDSEQ'] ==item['IDSEQ']){
                                item['ISALLO'] ='Y'
                            }
                        })
               
                    })
                })  
            },
            delRec4(row,index){
                this.$Modal.confirm({
                    title: '删除确认',
                    content: '<p>你确定要删除此报表吗</p>',
                    onOk: () => {
                        //发起删除请求
                        var vm=this;
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'sys_rep'},
                        }).then(res=>{      
                            if(res.code ==='200')  {           
                                vm.repData.splice(index,1);     
                            }else{
                                if (res.result.indexOf('ORA-02292')>-1) {   
                                    this.promptWin =true
                                    this.prompt ='存在子记录,不能删除'
                                }else{
                                    this.promptWin =true
                                    this.prompt = res.result
                                }
                            }        
                        }) 
                    }
                });
            },
            editRec4(row){
                this.repWin =true
                this.repFlag ='edit'
                this.repRow = JSON.parse(JSON.stringify(row))
            },
            tableMore(n){
                return () => this.rangeNumber += 20
            },
            //模块--报表删除
            delRec5(row){
                this.$Modal.confirm({
                    title: '删除确认',
                    content: '<p>你确定要删除此模块下的报表吗</p>',
                    onOk: () => {
                        //发起删除请求
                        var vm=this;
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'sys_mod_rep'},
                        }).then(res=>{      
                            if(res.code ==='200')  {           
                                vm.getModFrmData(this.modidseq);     
                            }else{
                                if (res.result.indexOf('ORA-02292')>-1) {   
                                    this.promptWin =true
                                    this.prompt ='存在子记录,不能删除'
                                }else{
                                    this.promptWin =true
                                    this.prompt = res.result
                                }
                            }        
                        }) 
                    }
                });
            },
            editRec5(row){  //模块-报表
                this.mrWin =true
                this.mrRow = JSON.parse(JSON.stringify(row))
            },
            mr_Save(){
                var vm=this;
                //发起保存请求   
                if (this.mrRow.REPIDSEQ)  {     
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(vm.mrRow), p_table:'sys_MOD_rep'},
                    }).then(res=>{      
                        if(res.result =='OK')  {          
                            vm.mrWin =false   
                            vm.getModFrmData(vm.modidseq);    
                        }else{
                            this.prompt =res.result
                            this.promptWin =true
                        }        
                    }) 
                }else{
                    this.prompt ='报表名称不能为空'
                    this.promptWin =true
                }
            } ,
            addRec5(){
                this.mrWin  =true
                this.mrRow ={'MODNM':this.modnm,'MODIDSEQ':this.modidseq}
            },
            tabClick(){
                if (this.tabVal =='tab04'){
                    if (this.repData.length>0){
                        this.$nextTick(()=>{
                            this.$refs['refrep'].setCurrentRow(this.repData[0] ,true)
                        })    
                    }
                }else if (this.tabVal =='tab02'){
                    if (this.frmData.length>0){
                        this.$nextTick(()=>{
                            this.$refs['formref'].setCurrentRow(this.frmData[0] ,true)
                        })    
                    }
                }
            },
            addRec4(){
                this.repWin =true
                this.repFlag='create'
                this.repRow ={}
            },
            qryRepData(){
                let cond_='' ,that=this
                if (this.selparam3){ //列1
                    if (this.oper3==='like'){
                        cond_=cond_+' and upper('+this.selparam3+') like upper(\'%' + this.txtparam3+'%\')'
                    }else{
                        cond_=cond_+' and upper('+this.selparam3+')' +this.oper3+'upper(\''+this.txtparam3+'\')'
                    }
                }
                getTabColOrData(this.v_url,'V_SYS_REP','','','','','','',cond_+' order by adddttm desc').then((res) => {
                    this.repData = res.result 
                })
            },
            repSave(){
                var vm=this;
                //发起保存请求   
                if (this.repRow.REPNM)  {     
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(vm.repRow), p_table:'sys_rep'},
                    }).then(res=>{      
                        if(res.result =='OK')  {          
                            vm.repWin =false   
                            vm.qryRepData()  
                        }else{
                            this.promptWin =true
                            this.prompt =res.result
                        }        
                    }) 
                }else{
                    this.prompt ='报表名称不能为空'
                    this.promptWin =true
                }
            } ,
            delGen(row,index){
                this.$confirm('你确定要删除此行记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_table:'SYS_FORM_GEN'},
                    }).then(res=>{ 
                        if(res.code==='200'){
                            this.genData.splice(index,1)
                        }
                    })
                }).catch(()=>{})
            },
            editGen(row,index){
                this.genWin =true
                this.genRow = JSON.parse(JSON.stringify(row))
            },
            getFrmRow(row){
                this.frmRow=row
                this.getGenData(row.IDSEQ)
            },
            //表单编码生成方式
            gen_Save(){
                if(this.genRow['ITMNO']){
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(Object.assign(this.genRow,{IDSEQ:this.frmRow['IDSEQ'],LSTSEQ:this.genRow['LSTSEQ']} )), p_table:'sys_form_gen',p_idseq:''},
                    }).then(res=>{
                        if(res.code==='200'){
                            this.genWin=false
                            this.getGenData(this.frmRow['IDSEQ'])
                        }else{
                            this.prompt=res.result
                            this.promptWin=true
                        }
                    })
                }else{
                    this.promptWin=true
                    this.prompt='项目名称不能为空'
                }
            },
            getGenData(idseq){
                getTabColOrData(this.v_url,'V_sys_form_gen','idseq',idseq).then((res) => {
                    this.genData =res.result  
                })
            },
            addGen(){
       
                if(Object.keys(this.frmRow).length===0){
                    this.promptWin=true
                    this.prompt='请选择一行表单记录'
                }else{
                    console.log('addgen ..')
                    this.genWin=true
                    this.genRow={LSTSEQ:''}
                }
            },
            modRow(row){
                this.modidseq =row.IDSEQ
                this.modnm =row.MODNM
                this.getModFrmData(row.IDSEQ)   
            } , 
            getFldKey(row){
                return row.IDSEQ
            },
            //确定
            modal_ok(){
                var vm=this;
                //发起保存请求   
                if (this.formCol.MODNM)  {     
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(vm.formCol), p_table:'sys_mod'},
                    }).then(res=>{      
                        if(res.result =='OK')  {          
                            vm.addModal =false   
                            vm.qryTabData()  
                        }else{
                            this.$Message.error(res.result)
                        }        
                    }) 
                }else{
                    this.$Message.error('模块名称不能为空')
                }
            } ,
            form_Save(){
                var vm=this;
                //发起保存请求   
                if (this.formRow.FRMNM)  {     
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(vm.formRow), p_table:'sys_form'},
                    }).then(res=>{      
                        if(res.result =='OK')  {          
                            vm.frmModal =false   
                            vm.qryFormData();    
                        }else{
                            this.$Message.error(res.result)
                        }        
                    }) 
                }else{
                    this.$Message.error('表单名称不能为空')
                }
            } ,
            mf_Save(){
                var vm=this;
                //发起保存请求   
                if (this.mfRow.FRMIDSEQ)  {     
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(vm.mfRow), p_table:'sys_MOD_form'},
                    }).then(res=>{      
                        if(res.result =='OK')  {          
                            vm.mfModal =false   
                            vm.getModFrmData(vm.modidseq);    
                        }else{
                            this.$Message.error(res.result)
                        }        
                    }) 
                }else{
                    this.$Message.error('表单名称不能为空')
                }
            } ,
            //获取单行表单字段
            getFormCol(){
                var vm=this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','88','lstseq','1','','').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.tabCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            edcss:res.result[k].EDCSS,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].SORTABLE,
                        })
                    }
                });
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','88','lstseq','2','','').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.frmArr.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].SORTABLE,
                        })
                    }
                });
                //模块表单
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','88','lstseq','3','','').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.mfArr.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            edcss:res.result[k].EDCSS,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].SORTABLE,
                        })
                    }
                })
                //表单编码方式
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','88','lstseq','4','','').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.genArr.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            edcss:res.result[k].EDCSS,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].SORTABLE,
                        })
                    }
                })
                //报表
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','88','lstseq','2503','','').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.repArr.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            edcss:res.result[k].EDCSS,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].SORTABLE,
                        })
                    }
                })
                //模块报表
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','88','lstseq','2504','','').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.mrArr.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].SORTABLE,
                        })
                    }
                })
            },
            //获取模块数据
            getModData(v_key,v_value,v_key2,v_value2,v_key3,v_value3,cond_){
                var vm=this
                getTabColOrData(this.v_likeurl,'v_SYS_MOD',v_key,v_value,v_key2,v_value2,v_key3,v_value3,cond_).then((res) => {
                    vm.baseData = res.result
                    if(res.result.length>0){
                        this.getModFrmData(res.result[0].IDSEQ)
                        this.modidseq =res.result[0].IDSEQ
                        this.modnm =res.result[0].MODNM
                    }
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout();
                    })
                });
            },
            //获取表单数据
            getFormData(v_key,v_value,v_key2,v_value2,v_key3,v_value3,cond ){
                let that =this
                getTabColOrData(this.v_likeurl,'v_SYS_FORM',v_key,v_value,v_key2,v_value2,v_key3,v_value3,cond+' order by adddttm desc').then((res) => {
                    this.frmData = res.result  
                })    
            },
            //获取模块--表单数据
            getModFrmData(modidseq){
                var vm=this
                getTabColOrData(this.v_url,'V_SYS_MOD_FORM','modidseq',modidseq,'','','','',' order by sortby').then((res) => {
                    vm.mfData = res.result
                })
                getTabColOrData(this.v_url,'V_SYS_MOD_REP','modidseq',modidseq,'','','','',' order by sortby').then((res) => {
                    vm.mrData = res.result
                })     
            },
 
            //查询事件
            qryTabData(){
                let cond_=''
                if (this.selparam){ //列1
                    if (this.oper==='like'){
                        cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                    }else{
                        cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                    }
                }
                this.getModData('','','','','','',cond_ );
            },
            qryFormData(){
                let cond_=''
                if (this.selparam2){ //列1
                    if (this.oper2==='like'){
                        cond_=cond_+' and upper('+this.selparam2+') like upper(\'%' + this.txtparam2+'%\')'
                    }else{
                        cond_=cond_+' and upper('+this.selparam2+')' +this.oper2+'upper(\''+this.txtparam2+'\')'
                    }
                }
                this.getFormData('','','','','','',cond_ );
            },
            // el-select 改变时 影响el-input 的 placeholder
            elchange(val){  // 这个val 就是 el-select 的 value
                let obj ={}
                obj =this.tabCol.find(item=>{
                    return item.key===val
                })
                this.input_hold='请输入'+obj.title+' 的值'
            },
            //新增
            addRec(){
                this.addModal =true
                this.type ='create'
                this.formCol ={ISFRONT:'N'}
            },
            addRec2(){
                this.frmModal =true
                this.frmtype ='create'
                this.formRow ={ISQRY:'N'}
            },
            addRec3(){
                this.mfModal =true
                this.mfRow ={'MODNM':this.modnm,'MODIDSEQ':this.modidseq}
            },
            //修改
            editRec(row){
                this.addModal =true
                this.type ='edit'
                this.formCol = JSON.parse(JSON.stringify(row))
            },
            editRec2(row){
                this.frmModal =true
                this.frmtype ='edit'
                this.formRow = JSON.parse(JSON.stringify(row))
            },
            editRec3(row){
                this.mfModal =true
                this.mfRow = JSON.parse(JSON.stringify(row))
            },
            //删除
            delRec(row){
                    this.$Modal.confirm({
                        title: '删除确认',
                        content: '<p>你确定要删除此行记录吗</p>',
                        onOk: () => {
                            //发起删除请求
                            var vm=this;
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'sys_mod'},
                            }).then(res=>{      
                                if(res.code ==='200')  {           
                                    vm.qryTabData()   
                                }else{
                                    if (res.result.indexOf('ORA-02292')>-1) {   
                                        this.$alert('存在子记录,不能删除', '提示', {
                                            confirmButtonText: '确定',
                                            showClose:false,
                                            type:'info'
                                        })
                                    }else{
                                        this.$alert(res.result, '提示', {
                                            confirmButtonText: '确定',
                                            showClose:false,
                                            type:'info'
                                        })
                                    }
                                }        
                            }) 
                        }
                    });
            },
            //表单删除
            delRec2(row){
                this.$Modal.confirm({
                    title: '删除确认',
                    content: '<p>你确定要删除此表单吗</p>',
                    onOk: () => {
                        //发起删除请求
                        var vm=this;
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'sys_form'},
                        }).then(res=>{      
                            if(res.code ==='200')  {           
                                vm.qryFormData();     
                            }else{
                                if (res.result.indexOf('ORA-02292')>-1) {   
                                    this.$alert('存在子记录,不能删除', '提示', {
                                        confirmButtonText: '确定',
                                        showClose:false,
                                        type:'info'
                                    })
                                }else{
                                    this.$alert(res.result, '提示', {
                                        confirmButtonText: '确定',
                                        showClose:false,
                                        type:'info'
                                    })
                                }
                            }        
                        }) 
                    }
                });
            },
            //模块--表单删除
            delRec3(row){
                this.$Modal.confirm({
                    title: '删除确认',
                    content: '<p>你确定要删除此模块下的表单吗</p>',
                    onOk: () => {
                        //发起删除请求
                        var vm=this;
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'sys_mod_form'},
                        }).then(res=>{      
                            if(res.code ==='200')  {           
                                vm.getModFrmData(this.modidseq);     
                            }else{
                                if (res.result.indexOf('ORA-02292')>-1) {   
                                    this.$alert('存在子记录,不能删除', '提示', {
                                        confirmButtonText: '确定',
                                        showClose:false,
                                        type:'info'
                                    })
                                }else{
                                    this.$alert(res.result, '提示', {
                                        confirmButtonText: '确定',
                                        showClose:false,
                                        type:'info'
                                    })
                                }
                            }        
                        }) 
                    }
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .input-with-select .el-input-group__prepend {
        background-color: #fff;
        width: 150px;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 3px ;
            font-size:11px;
        }   
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>

 
